<template>
  <div data-app>
    <div class="uk-card uk-card-small uk-card-default uk-animation-fade">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.title_page_salary }}
              <span class="uk-label tm-label">Beta</span>
              <div style="width:300px"
                   class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                {{local_page_keys.alert_test_version}}
              </div>
            </div>
          </div>
          <div class="uk-width-auto">
            <div class="uk-padding-xsmall" style="background-color: #4caf50;color: #fff;">
              {{ local_page_keys.to_payoff}} {{ totalWholeSumForUnpaidReports}}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body_">
        <!--шапка-->
        <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-center uk-text-small"
             data-uk-grid
             data-uk-height-match="target: > div > div"
             data-uk-sticky="start: 200; animation: uk-animation-slide-top"
             style="background-color: #fff;">
          <div class="tm-width-medium">
            <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center">
              <div class="uk-text-bold uk-text-muted" style="line-height: 1.2;">
                {{ local_page_keys.weeks }}
              </div>
            </div>
          </div>
          <div class="uk-width-expand">
            <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields.length+1)+' tm-child-width-1-'+(fields.length+1)"
                 data-uk-grid
                 data-uk-height-match="target: .uk-padding-xsmall">
              <div v-for="(field,index) in fields" :key="index">
                <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                  <div class="uk-text-bold uk-text-muted" style="line-height: 1.2;">
                    {{ local_page_keys[field.name] }}
                  </div>
                  <div v-if="getTooltip(field.name)"
                       class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                    {{getTooltip(field.name)}}
                  </div>
                </div>
              </div>
              <div>
                <div class="uk-padding-xsmall uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                  <div class="uk-text-bold uk-text-muted" style="line-height: 1.2;">
                    {{ local_page_keys.paid }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="uk-margin-remove">
        <!--строка-->
        <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-1 tm-grid-hover uk-text-small" data-uk-grid>
          <template v-for="(itemWeek) in items">
            <template v-for="(item, index) in itemWeek">
            <div v-if="item"
                 class="uk-animation-fade uk-animation-fast uk-position-relative 444"
                 :style="'z-index:' + item.date.week"
                 :key="item.date.week + '_' + index"
                 :id="item.date.week">
              <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-text-center"
                   data-uk-grid
                   data-uk-height-match="target: > div > div">
                <!--номер недели-->
                <div class="uk-text-left tm-width-medium">
                  <div v-if="item.date" class="uk-padding-xsmall uk-flex uk-flex-middle_ uk-flex-column">
                    <div class="uk-text-bold">
                      {{ item.date.week ? item.date.week : '-' }}
                    </div>
                    <div class="tm-text-small uk-text-muted" style="line-height: 1">
                      ({{ item.date.start ? item.date.start : '-' }} / {{ item.date.end ? item.date.end : '-' }})
                    </div>
                  </div>
                </div>
                <div class="uk-width-expand">
                 <div :class="'uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-'+(fields.length+1)+' tm-child-width-1-'+(fields.length+1)"
                      data-uk-grid
                      data-uk-height-match="target: > div > div">
                   <div v-for="(field, fieldKey) in fields" :key="fieldKey">
                     <div class="uk-padding-small uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                       <div :class="field.class">
                         {{ prepareValue(field.name, item)}}
                       </div>
                       <RatingDialog v-if="field.name === 'place_bonus' && item.report['place_bonus']"
                                     :bonus-data="getBonusData(item.report)"
                                     :dialogClass="'tm-dropdown-bottom-center'"
                                     :dialogOffset="'10'"
                                     :dialogPosition="'bottom-center'"/>
                       <div v-if="item.report[field.name] > 0 && getTooltipData(item,field.name)"
                            :id="'tooltipData' + fieldKey"
                            style="width:400px"
                            class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                            data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 10">
                         <div class="uk-text-left" v-html="getTooltipData(item,field.name)"></div>
                       </div>
                     </div>
                   </div>
                   <div>
                     <div class="uk-padding-small uk-flex uk-flex-middle uk-flex-column uk-flex-center">
                      {{ item.report['date'] }}
                     </div>
                   </div>
                 </div>
                </div>
              </div>
            </div>
          </template>
          </template>
        </div>
        <hr class="uk-margin-remove">
        <!--кнопка-->
        <div class="uk-margin uk-text-center">
          <button
             @click="getMore"
             :disabled="loadingRaw"
             class="uk-button uk-button-success tm-light">
            <md-icon>add</md-icon>
            <span v-if="loadingRaw" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RatingDialog from "@/pages/Dashboard/Components/Dialogs/RatingDialog.vue";

export default {
  data() {
    return {
      local_page_keys: {},
      fields: [
        {
          name: 'num_orders',
          class: ''
        },
        {
          name: 'all_pro_hours_good_sum',
          class: ''
        },
        {
          name: 'shift_salary',
          class: 'uk-text-bold'
        },
        {
          name: 'all_bonus_for_pro',
          class: ''
        },
        {
          name: 'all_bonus_money',
          class: 'uk-text-bold'
        },
        {
          name: 'month_bonus',
          class: 'uk-text-bold'
        },
        {
          name: 'place_bonus',
          class: 'uk-text-bold'
        },

        {
          name: 'additional_payment',
          class: 'uk-text-bold'
        },
        {
          name: 'whole_sum',
          class: 'uk-text-bold'
        },
        // 'paid'
      ],
      loadingRaw: false,
      moreItemsButton: true,
      page: 0,
      items: [],
      loading: false
    }
  },
  components: {RatingDialog},
  computed: {
    totalWholeSumForUnpaidReports() {
      // return this.items.reduce((total, innerArray) => {
      //   const innerTotal = innerArray.reduce((innerAcc, report) => {
      //     if (report.report.date === null) {
      //       return Math.ceil(innerAcc + report.report.whole_sum);
      //     } else {
      //       return Math.ceil(innerAcc);
      //     }
      //   }, 0);
      //   return Math.ceil(total + innerTotal);
      // }, 0);
      if (this.items && this.items.length > 0 && this.items[0] && this.items[0].length > 0) {
        const report = this.items[0][0]["report"];
        if (report && report.date === null) {
          return Math.ceil(report.whole_sum);
        }
      }
      return 0;
    }
  },
  methods: {
    async getMore() {
      if (!this.moreItemsButton) {
        return;
      }
      this.loadingRaw = true;
      this.moreItemsButton = false;
      let error = "";
      let formData = new FormData();
      formData.append('page', this.page);
      await this.$store.dispatch('salary/reportProRetoucherSalaryData', formData).catch((reason => {
        this.moreItemsButton = true;
        error = true;
      }));
      if (!error) {
        let row = await this.$store.getters['salary/reportProRetoucherSalaryData'];
        this.items.push(row['data']);
        this.page++;
        this.moreItemsButton = true;
      }
      this.loadingRaw = false;
    },
    getTooltip(field) {
      let tooltipName = 'tooltip_' + field;
      return this.local_page_keys[tooltipName];
    },
    getTooltipData(item, field) {
      let tooltipName = 'tooltip_data_' + field;
      return item.tooltip_data[tooltipName];
    },
    prepareValue(name, item) {
      if (name === 'all_bonus_for_pro' && item.report.length > 0 ) {
        return item.report['weekly_bonus']  + '%-' +  item.report['additional_penalty_pro'] + '%+' +  item.report['additional_bonus_pro'] + '%=' +  item.report['all_bonus_for_pro'] + '%';
      }
      return item.report[name];
    },
    getBonusData(item) {
      return {
        type: 'old',
        now: item['place_bonus_in_percent'],
        place: item['place'],
        rating: [
          {'place': 1, 'now': item['rank_1']},
          {'place': 2, 'now': item['rank_2']},
          {'place': 3, 'now': item['rank_3']}
        ]
      }
    }
  },

  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('salary');
    this.getMore();
  },

}
</script>
<style></style>